import { render } from "./ClearHistory.vue?vue&type=template&id=1383c17e"
import script from "./ClearHistory.vue?vue&type=script&lang=js"
export * from "./ClearHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__